import Reveal from '@/components/base/Reveal';

const TRUST = [
  { icon: 'ri-scissors-2-line', title: 'Traditional Collections', text: 'Indian-inspired clothing and textiles' },
  { icon: 'ri-map-pin-line', title: 'UK Focused', text: 'Serving customers across the UK' },
  { icon: 'ri-chat-1-line', title: 'Personal Service', text: 'Speak directly with the SRM team' },
  { icon: 'ri-store-2-line', title: 'Real-World Presence', text: 'Discover SRM through its market presence' },
];

export default function TrustStrip() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 divide-background-200">
          {TRUST.map((item, i) => (
            <Reveal
              key={item.title}
              delay={i * 90}
              className="flex items-start gap-4 py-6 md:py-8 lg:px-5 first:lg:pl-0"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-primary-600">
                <i className={`${item.icon} text-lg`} aria-hidden="true" />
              </span>
              <div>
                <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-[13px] leading-snug text-foreground-600">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}